import { toast } from "react-toastify"
import React from "react"
import ToastInfo from "../components/ToastContents/ToastInfo"

const DEFAULT_RATE_LIMIT_MESSAGE =
  "You've made too many attempts. Please wait a minute and try again."

export const isRateLimitError = (error) => error?.response?.status === 429

export const getRetryAfterSeconds = (error) => {
  const value = Number(error?.response?.data?.retry_after)
  return Number.isFinite(value) && value > 0 ? Math.ceil(value) : 0
}

export const formatRetryAfter = (seconds) => {
  const s = Math.max(0, Math.ceil(Number(seconds) || 0))
  if (s <= 0) return "Try again shortly."
  if (s === 1) return "Try again in 1 second."
  if (s < 60) return `Try again in ${s} seconds.`
  const minutes = Math.floor(s / 60)
  const rem = s % 60
  if (rem === 0) {
    return `Try again in ${minutes} minute${minutes === 1 ? "" : "s"}.`
  }
  return `Try again in ${minutes} minute${
    minutes === 1 ? "" : "s"
  } and ${rem} second${rem === 1 ? "" : "s"}.`
}

const baseRateLimitMessage = (error) => {
  const apiMessage = error?.response?.data?.error
  if (apiMessage && typeof apiMessage === "string") {
    return apiMessage
      .replace(/\s*Try again in .+$/i, "")
      .replace(/\.\s*$/, "")
      .trim()
  }
  return DEFAULT_RATE_LIMIT_MESSAGE.replace(/\.\s*$/, "")
}

export const getMfaRateLimitMessage = (error, remainingSeconds) => {
  const remaining =
    remainingSeconds != null
      ? Math.ceil(Number(remainingSeconds) || 0)
      : getRetryAfterSeconds(error)

  const base = baseRateLimitMessage(error)
  if (remaining > 0) {
    return `${base}. ${formatRetryAfter(remaining)}`
  }

  const apiMessage = error?.response?.data?.error
  if (apiMessage && typeof apiMessage === "string") {
    return apiMessage
  }
  return DEFAULT_RATE_LIMIT_MESSAGE
}

export const showMfaRateLimitToast = (error) => {
  toast.error(<ToastInfo>{getMfaRateLimitMessage(error)}</ToastInfo>, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 5000,
    pauseOnHover: true,
    closeOnClick: true,
  })
}

export const getMfaErrorMessage = (error) =>
  error?.response?.data?.error || "Invalid or expired verification code."

/** Session fully gone (TTL expired) — user must return to login */
export const isMfaSessionExpiredError = (error) => {
  const message = getMfaErrorMessage(error).toLowerCase()
  return (
    message.includes("session has expired") ||
    message.includes("return to login and sign in")
  )
}

/** Too many wrong OTPs — resend still allowed */
export const isMfaExhaustedError = (error) => {
  const message = getMfaErrorMessage(error).toLowerCase()
  return message.includes("too many incorrect attempts")
}
